"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoReactInternals = exports.random = exports.interpolate = void 0;
var interpolate_1 = require("./interpolate");
Object.defineProperty(exports, "interpolate", { enumerable: true, get: function () { return interpolate_1.interpolate; } });
var random_js_1 = require("./random.js");
Object.defineProperty(exports, "random", { enumerable: true, get: function () { return random_js_1.random; } });
const delay_render_1 = require("./delay-render");
const input_props_serialization_1 = require("./input-props-serialization");
const input_props_serialization_js_1 = require("./input-props-serialization.js");
const interpolate_colors_1 = require("./interpolate-colors");
const truthy_1 = require("./truthy");
const v5_flag_1 = require("./v5-flag");
const validate_frame_1 = require("./validate-frame");
const validate_default_props_1 = require("./validation/validate-default-props");
const validate_dimensions_1 = require("./validation/validate-dimensions");
const validate_duration_in_frames_1 = require("./validation/validate-duration-in-frames");
const validate_fps_1 = require("./validation/validate-fps");
const get_current_time_1 = require("./video/get-current-time");
const offthread_video_source_1 = require("./video/offthread-video-source");
exports.NoReactInternals = {
    processColor: interpolate_colors_1.processColor,
    truthy: truthy_1.truthy,
    validateFps: validate_fps_1.validateFps,
    validateDimension: validate_dimensions_1.validateDimension,
    validateDurationInFrames: validate_duration_in_frames_1.validateDurationInFrames,
    validateDefaultAndInputProps: validate_default_props_1.validateDefaultAndInputProps,
    validateFrame: validate_frame_1.validateFrame,
    serializeJSONWithDate: input_props_serialization_1.serializeJSONWithDate,
    bundleName: 'bundle.js',
    bundleMapName: 'bundle.js.map',
    deserializeJSONWithCustomFields: input_props_serialization_1.deserializeJSONWithCustomFields,
    DELAY_RENDER_CALLSTACK_TOKEN: delay_render_1.DELAY_RENDER_CALLSTACK_TOKEN,
    DELAY_RENDER_RETRY_TOKEN: delay_render_1.DELAY_RENDER_RETRY_TOKEN,
    DELAY_RENDER_ATTEMPT_TOKEN: delay_render_1.DELAY_RENDER_RETRIES_LEFT,
    getOffthreadVideoSource: offthread_video_source_1.getOffthreadVideoSource,
    getExpectedMediaFrameUncorrected: get_current_time_1.getExpectedMediaFrameUncorrected,
    ENABLE_V5_BREAKING_CHANGES: v5_flag_1.ENABLE_V5_BREAKING_CHANGES,
    MIN_NODE_VERSION: v5_flag_1.ENABLE_V5_BREAKING_CHANGES ? 18 : 16,
    MIN_BUN_VERSION: v5_flag_1.ENABLE_V5_BREAKING_CHANGES ? '1.1.3' : '1.0.3',
    colorNames: interpolate_colors_1.colorNames,
    DATE_TOKEN: input_props_serialization_js_1.DATE_TOKEN,
    FILE_TOKEN: input_props_serialization_js_1.FILE_TOKEN,
};
